































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import PolicyLoader from './PolicyLoader.vue';

const AppModule = namespace('App');

@Component({
  components: {
    PolicyLoader,
  },
})
export default class PolicyDesktopModal extends Vue {
  private visibility = false;

  @AppModule.Action
  private getPolicy: ()=> any;

  @AppModule.State
  private policy: String;

  @AppModule.State
  private policyLoading: Boolean;

  private showPolicy() {
    this.visibility = true;

    if (!this.policyLoading && !this.policy) {
      this.getPolicy();
    }
  }
}
